import { GetterTree } from "vuex";
import { StoreState } from "@/store/type";
import { IEntityBulkAssignmentState } from "../types";
import { ENTITY_TYPE_CONFIG } from "../constants";

const getters: GetterTree<IEntityBulkAssignmentState, StoreState> = {
  isBulkAssignmentActive: (state) => state.isWorkflowActive,
  bulkAssignmentStep: (state) => state.currentStep,
  bulkAssignmentEntity: (state) => state.entity,
  bulkAssignmentEntityType: (state) => state.entityType,
  bulkAssignmentOrganizationId: (state) => state.organizationId,
  bulkAssignmentEmployees: (state) => state.assignedEmployees,
  bulkAssignmentEmployeesPaginationMeta: (state) => state.employeesPaginationMeta,
  bulkAssignmentEmployeesSearchQuery: (state) => state.employeesSearchQuery,
  bulkAssignmentEmployeesPageNo: (state) => state.employeesPageNo,
  isFetchingBulkAssignmentEmployees: (state) => state.isFetchingEmployees,
  isBulkAssigning: (state) => state.isAssigning,
  bulkAssignmentOptions: (state) => state.assignmentOptions,
  isFetchingBulkAssignmentOptions: (state) => state.isFetchingAssignmentOptions,
  bulkAssignmentLastSuccessfulAssignment: (state) =>
    state.lastSuccessfulAssignment,
  remainingEmployeeCount: (state) =>
    state.employeesPaginationMeta?.total_records ??
    state.assignedEmployees.length,
  bulkAssignmentEntityConfig: (state) =>
    state.entityType ? ENTITY_TYPE_CONFIG[state.entityType] : null,
};

export default getters;
